<template>
    <b-container fluid class="px-0">
        <b-row class="mb-3">
            <b-col cols="12" lg="6" xl="3" md="6" class="mb-3 mb-xl-0">
                <b-input-group>
                    <template v-slot:prepend>
                        <b-btn style="cursor:default;" class="font-weight-bold">Server Name</b-btn>
                    </template>
                    <b-form-select v-model="filter.ServerName" value-field="fullName" text-field="fullName" :options="servers" @change="changeServerName"></b-form-select>
                </b-input-group>
            </b-col>
            <b-col cols="12" lg="6" xl="3" md="6" class="mb-3 mb-xl-0">
                <b-input-group prepend="From Date">
                    <b-form-datepicker
                        locale="en-US"
                        :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                        id="from-example-datepicker"
                        :min="oldestDate"
                        :max="maxDateByToDate"
                        v-model="filter.FromDate"
                        @input="DateChange"></b-form-datepicker>
                </b-input-group>
            </b-col>
            <b-col cols="12" lg="6" xl="3" md="6">
                <b-input-group prepend="To Date">
                    <b-form-datepicker
                            locale="en-US"
                            :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                            id="to-example-datepicker" :min="minDate" :max="maxDate"  v-model="filter.ToDate" @input="DateChange"></b-form-datepicker>
                </b-input-group>
            </b-col>
            <b-col cols="12" lg="6" xl="3" sm="6" class="mt-3 mt-md-0">
                <b-button-group>
                    <b-button @click="changeDateMode('yesterday')" :class="type === 'yesterday' && isVisibleYesterday ? 'active-button-group' : 'bg-white'">Yesterday</b-button>
                    <b-button @click="changeDateMode('today')" :class="type === 'today' && isVisibleToday ? 'active-button-group' : 'bg-white'">Today</b-button>
                </b-button-group>

            </b-col>
        </b-row>
        <b-row class="mb-3 mt-4 pb-4 d-flex justify-content-center" style="border-bottom: 1px solid #d7d1d1;"> 
            <b-btn v-if="!loading" variant="warning" style="width: 14rem;font-size: 1.2rem;" class="font-weight-bold" block @click="GetServerReport(filter)">Create Report</b-btn>
            <b-btn v-else variant="warning" style="width: 14rem;font-size: 1.2rem;" class="font-weight-bold" block @click="GetServerReport(filter)" :disabled="loading">
               <div class="d-flex justify-content-center align-items-center"> Creating Report...     <b-spinner small class="ml-2"></b-spinner></div>
           
            </b-btn>
        </b-row>
        <b-row class="mb-4" v-if="result.length">
            <b-col cols="12" md="3">
                <b-row>
                    <b-col cols="12">
                        <b-row>
                            <b-col cols="12">
                                <div class="mb-4">
                            <b-btn class="mb-3"  variant="warning" :disabled="loading" block @click="handlePrintShiftReceipt">
                                Print Shift Receipt (Report Summary)
                            </b-btn>

                            <b-btn class="mb-3" variant="warning" block @click="print">
                                Print Page (Full Report)
                            </b-btn>

                            <b-btn class="mb-3" variant="warning" block @click="download(filter)">
                                Download File
                            </b-btn>
                        </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <report-summery :value="result[0]" :filter="filter"/>
                        </b-row>
                        
                    
                        
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="9">
                
                <b-row class="border-bottom-blueGray pb-4" v-for="(item, index) in result" :class="index < result.length - 1 ? 'mb-5' : ''">
                    <b-col cols="12" v-if="index === 0">
                        <section class="mb-3">
                            <div class="text-center h5 font-weight-bold">
                                End of Day
                            </div>
                            <div v-if="filter.FromDate === filter.ToDate" class="text-center h5 font-weight-bold">
                                For {{convertDate(filter.FromDate, 'noTime')}}
                            </div>
                            <div v-else class="text-center h5 font-weight-bold">
                                For {{convertDate(filter.FromDate, 'noTime')}} - {{convertDate(filter.ToDate, 'noTime')}}
                            </div>
                            <div class="text-center" v-if="result.length">
                                Created on {{convertDate(new Date(), false)}}
                            </div>
                        </section>
                    </b-col>

                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Server: {{item.ServerName}}
                            </div>
                            <div class="font-weight-bold">
                                Total Gross Sales:
                                <currency-display :value="item.Gross_Sale"/>
                            </div>
                            <!-- <div>
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Gross_Sale_NAL_Drink + item.Gross_Sale_Food"/>
                            </div>
                            <div>
                                Alcoholic Drinks:
                                <currency-display :value="item.Gross_Sale_AL_Drink"/>
                            </div> -->
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Tax:
                                <currency-display :value="item.Taxes"/>
                            </div>
                            <div>
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Tax_Food_NAL_Drink"/>
                            </div>
                            <div>
                                Alcoholic Drinks:
                                <currency-display :value="item.Tax_Alc_Drink"/>
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Tip Out to House:
                                <currency-display :value="item.Tip_Outhouse"/>
                            </div>
                            <div class="font-weight-bold">
                                    Total Cash Collected:
                                    <currency-display :value="item.Paymeny_Received_Cash"/>
                                </div>
                            <div class="font-weight-bold">
                                Cash Owed to House:
                                <currency-display v-if="item.Server_Balance <= 0" :value="Math.abs(item.Server_Balance)"/>
                                <span v-else>$0.00</span>
                            </div>
                            <div class="font-weight-bold">
                                Money Owed to Server:
                                <currency-display v-if="item.Server_Balance > 0 " :value="Math.abs(item.Server_Balance)"/>
                                <span v-else>$0.00</span>
                            </div>
                        </section>
                        <section v-if="categoriesSold.length > 0">
                            <div class="font-weight-bold" >
                                Categories Sold (QTY | Gross Sales):
                            </div>
                        </section>
                            
                        
                        <section class="mb-4 item-group" v-if="categoriesSold.length > 0">
                            
                                <div v-for="category in categoriesSold" :key="category.ItemName + index">
                                    <div>{{"- "+category.ItemName + " | Qty: "}}{{ category.Qty }} {{' | Gross:'+currencyFormat(category.Amount)}}</div>
                                </div>
                        </section>
                        
                        
                    </b-col>
                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Credit (Comp & Discount) Applied:
                                <currency-display :value="item.Credits"/>

                            </div>
                            <div class="font-weight-bold">
                                Total Refunds:
                                <currency-display :value="item.Refunds"/>
                            </div>
                            <div class="font-weight-bold">
                                Total Voids (Cancelled Orders)
                                <currency-display :value="item.Voids"/>
                            </div>
                            <div class="invisible">
                                d
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Tip:
                                <currency-display :value="item.Tips"/>
                            </div>
                            <div>
                                Card:
                                <currency-display :value="item.Tip_Card"/>
                            </div>
                            <div>
                                Cash:
                                <currency-display :value="item.Tip_Cash"/>
                            </div>
                            <div>
                               <span> Other(All):<currency-display :value="otherPaymentBreakdown.reduce((acc, curr) => acc + curr.Tip_OtherPaid, 0)"/> </span>
                                <span style="font-size: 0.8rem; color: #7878e8" v-if="otherPaymentBreakdown.length > 0 && !showOtherTipBreakdown" @click="showOtherTipBreakdown = true">See Breakdown</span>
                                <span style="font-size: 0.8rem; color: #7878e8" v-else-if="showOtherTipBreakdown" @click="showOtherTipBreakdown = false">Hide Breakdown</span>
                                
                                <div v-if="showOtherTipBreakdown">
                                    <div v-for="otherPayment in otherPaymentBreakdown" :key="otherPayment.PaymentSource">
                                        <div class="ml-2">• {{otherPayment.PaymentMethodName}} : {{currencyFormat(otherPayment.Tip_OtherPaid)}}</div>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section v-if="itemsSold.length > 0">
                            <div class="font-weight-bold" >
                                    Items Sold (QTY | Gross Sales):
                                </div>
                        </section>
                        <section class="mb-4 item-group" v-if="itemsSold.length > 0">
                                
                            <div class="font-weight-bold">Food:</div>
                            <div v-for="(foodItem, foodIndex) in itemsSold.filter(item => item.ItemType == 'Food')" :key="foodItem.ItemName + foodIndex">
                                <div>
                                    {{"- "+foodItem.ItemName + " | Qty:"}}{{ foodItem.Qty }} {{" | Gross:" + currencyFormat(foodItem.Amount)}}
                                </div>
                            </div>
                            <div class="font-weight-bold" style="color:#0000EE">Drinks:</div>
                            <div v-for="(drinkItem, drinkIndex) in itemsSold.filter(item => item.ItemType == 'Drink')" :key="drinkItem.ItemName + drinkIndex">
                                <div style="color:#0000EE">
                                    {{"- "+drinkItem.ItemName + " | Qty:"}}{{ drinkItem.Qty }} {{" | Gross:" + currencyFormat(drinkItem.Amount)}}
                                </div>
                            </div>
                        </section>
                       
                    </b-col>
                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Net Sales (Gross Sales - Credit - Refund):
                                <currency-display :value="item.Net_Sale"/>
                            </div>
                            <div class="">
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Net_Sale_NAL_Drink + item.Net_Sale_Food"/>
                            </div>
                            <div class="">
                                Alcoholic Drinks:
                                <currency-display :value="item.Net_Sale_AL_Drink"/>
                            </div>
                            <div class="invisible">
                                d
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Payments Collected (Net Sales + Tax + Tip):
                                <currency-display :value="item.Paymeny_Received"/>
                            </div>
                            <div>
                                Card:
                                <currency-display :value="item.Paymeny_Received_Card"/>
                            </div>
                            <div>
                                Cash:
                                <currency-display :value="item.Paymeny_Received_Cash"/>
                            </div>
                            <div>
                                <div>
                               <span > Other(All):<currency-display :value="otherPaymentBreakdown.reduce((acc, curr) => acc + curr.Paymeny_Received_OtherPaid, 0)"/> </span>
                                <span style="font-size: 0.8rem; color: #7878e8" v-if="otherPaymentBreakdown.length > 0 && !showOtherPaymentBreakdown" @click="showOtherPaymentBreakdown = true">See Breakdown</span>
                                <span style="font-size: 0.8rem; color: #7878e8" v-else-if="showOtherPaymentBreakdown" @click="showOtherPaymentBreakdown = false">Hide Breakdown</span>
                                
                                <div v-if="showOtherPaymentBreakdown">
                                    <div v-for="otherPayment in otherPaymentBreakdown" :key="otherPayment.PaymentSource">
                                        <div class="ml-2">• {{otherPayment.PaymentMethodName}} : {{currencyFormat(otherPayment.Paymeny_Received_OtherPaid)}}</div>
                                    </div>
                                </div>

                            </div>
                            </div>
                        </section>
                        <!-- <section class="mb-4">
                            <div class="font-weight-bold">
                                Total Payments Received (Restaurant Total) Average:
                                <currency-display :value="item.Avg_Paymeny_Received"/>
                            </div>

                            <div class="font-weight-bold">
                                Standard Deviation:
                                <currency-display :value="stddev_totalpayment_received"/>
                                                                   <currency-display :value="item.Paymeny_Received_Cash"/>
                            </div>
                        </section> -->
                        <section>
                            <div class="">
                                Number of Orders: {{item.No_Of_Tabs}}
                            </div>
                            <div class="">
                                Average Order Value (Gross Sales):
                                <currency-display :value="item.Avg_Tab_Amount"/>
                            </div>
                            <div class="">
                                Standard Deviation Amount (Gross Sales):
                                <currency-display :value="stddev_tab_amount"/>
                            </div>
                            <div class="">
                                Average Tip Percentage: {{item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : 0}}%
                            </div>

                            <section v-if="orderSources.length > 0" class="my-4">
                                <div class="font-weight-bold" >
                                    Order Source - Type Breakdown (QTY | Gross Sales):
                                </div>
                                <div v-for="orderSource in orderSources" :key="orderSource.Source">
                                    <div class="mt-3">{{orderSource.Source}} | Qty: {{orderSource.Qty}} | Gross: {{currencyFormat(orderSource.Amount)}}</div>
                                    
                                    <div v-for="orderType in orderTypes" >
                                        <div v-if="orderType.Source == orderSource.Source" class="ml-2 ">
                                            • {{orderType.TypeName}} | Qty: {{orderType.Qty}} | Gross: {{currencyFormat(orderType.Amount)}}
                                       
                                        </div>
                                    </div>
                                
                                </div>
                            </section>






                            <div class="" v-if="result[0].No_Of_Tabs > 10">
                                <span v-if="!showAllServedTabs">Served Tab Nos: {{ getServedTabs(item.Serverd_Tabs)}}</span>
                                <span v-else>Served Tab Nos: {{ getServedTabsAll(item.Serverd_Tabs)}}</span>
                                
                                <span v-if="!showAllServedTabs" style="color: #0000EE; text-decoration: underline; font-size: 1.1rem;" class="font-weight-bold" @click="showAllServedTabs = !showAllServedTabs">...</span>
                                <span v-else style=" font-size: 1.1rem;" class="font-weight-bold text-danger" @click="showAllServedTabs = !showAllServedTabs">X</span>
                            </div>
                            <div class="" v-else>
                                Served Tab Nos: {{ getServedTabsAll(item.Serverd_Tabs)}}
                            </div>
                        </section>
                        
                    </b-col>
                </b-row>
            </b-col>
            
        </b-row>
        <b-row v-else>
            <b-col class="text-danger text-center h4 mt-4 font-weight-bold" v-if="canShowErr && !loading && result.length === 0">
                {{errorTextApi}}
<!--                No tabs exists for this server for the selected period.-->
            </b-col>
        </b-row>
        <b-row v-if="result.length">
            <b-col class="pb-3">
                Note: Sales numbers are rouned to the nearest cent and may vary slightly from report to report.
            </b-col>
        </b-row>
        <vue-easy-print tableShow ref="easyPrint">
            <template slot-scope="func">
                <b-container id="printSection">
                    <b-row v-for="item in result">
                        <b-col cols="12">
                            <div class="font-weight-bold text-center">
                                {{item.RestaurantName}}
                            </div>
                            <div class="font-weight-bold text-center">
                                Server Shift report
                            </div>
                            <div v-if="filter.FromDate === filter.ToDate" class="text-center h5 font-weight-bold">
                                For {{convertDate(filter.FromDate, 'noTime')}}
                            </div>
                            <div v-else class="text-center h5 font-weight-bold">
                                For {{convertDate(filter.FromDate, 'noTime')}} - {{convertDate(filter.ToDate, 'noTime')}}
                            </div>
                            <div class="text-center">
                                Server: {{filter.ServerName}}
                            </div>
                            <div class="mb-4 text-center">
                                Created on date time: {{convertDate(new Date(), false) }}
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Gross Sales:
                                    <currency-display :value="item.Gross_Sale + item.Gross_Sale_Food"/>
                                </div>
                                <!-- <div class="">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Gross_Sale_NAL_Drink + item.Gross_Sale_Food"/>
                                </div>
                                <div class="">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Gross_Sale_AL_Drink"/>
                                </div> -->
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Tax:
                                    <currency-display :value="item.Taxes"/>
                                </div>
                                <div class="font-weight-bold">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Tax_Food_NAL_Drink"/>
                                </div>
                                <div class="font-weight-bold">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Tax_Alc_Drink"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Tip Out to House:
                                    <currency-display  :value="item.Tip_Outhouse"/>
                                </div>
                                <div class="font-weight-bold">
                                    Total Cash Collected:
                                    <currency-display :value="item.Paymeny_Received_Cash"/>
                                </div>
                                <div class="font-weight-bold">
                                    Cash Owed to House:
                                    <currency-display v-if="item.Server_Balance <= 0" :value="Math.abs(item.Server_Balance)"/>
                                    <span v-else>$0.00</span>
                                </div>
                                <div class="font-weight-bold">
                                    Money Owed to Server:
                                    <currency-display v-if="item.Server_Balance > 0" :value="Math.abs(item.Server_Balance)"/>
                                    <span v-else>$0.00</span>
                                </div>
                            </section>
                        
                        <section v-if="categoriesSold.length > 0">
                            <div class="font-weight-bold" >
                                Categories Sold (QTY | Gross Sales):
                            </div>
                        </section>
                            
                        
                        <section class="mb-4 item-group" v-if="categoriesSold.length > 0">
                            
                                <div v-for="(category, index) in categoriesSold" :key="category.ItemName + index">
                                    <div>{{"- "+category.ItemName + " | Qty: "}}{{ category.Qty }} {{' | Gross:'+currencyFormat(category.Amount)}}</div>
                                </div> 
                        </section>
                        
                        
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Credit (Comp & Discount) Applied:
                                    <currency-display :value="item.Credits"/>
                                </div>
                                <div class="font-weight-bold">
                                    Total Refunds:
                                    <currency-display :value="item.Refunds"/>
                                </div>
                                <div class="font-weight-bold">
                                    Total Voids (Cancelled Orders)
                                    <currency-display :value="item.Voids"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Tip:
                                    <currency-display :value="item.Tips"/>
                                </div>
                                <div class="">
                                    Card Pay:
                                    <currency-display :value="item.Tip_Card"/>
                                </div>
                                <div class="">
                                    Cash Pay:
                                    <currency-display :value="item.Tip_Cash"/>
                                </div>
                                <div class="">
                                    <span> Other(All):<currency-display :value="otherPaymentBreakdown.reduce((acc, curr) => acc + curr.Tip_OtherPaid, 0)"/> </span>
                                </div>
                                <div v-for="otherPayment in otherPaymentBreakdown" :key="'tip-print-'+otherPayment.PaymentSource">
                                    <div class="ml-2">• {{otherPayment.PaymentMethodName}} : {{currencyFormat(otherPayment.Tip_OtherPaid)}}</div>
                                </div>
                            </section>
                            <section v-if="itemsSold.length > 0">
                            <div class="font-weight-bold" >
                                    Items Sold (QTY | Gross Sales)
                                </div>
                        </section>
                        <section class="mb-4 item-group" v-if="itemsSold.length > 0">
                                
                            <div class="font-weight-bold">Food:</div>
                            <div v-for="(foodItem, foodIndex) in itemsSold.filter(item => item.ItemType == 'Food')" :key="foodItem.ItemName + foodIndex">
                                <div>
                                    {{"- "+foodItem.ItemName + " | Qty:"}}{{ foodItem.Qty }} {{" | Gross:" + currencyFormat(foodItem.Amount)}}
                                </div>
                            </div>
                            <div class="font-weight-bold" style="color:#0000EE">Drinks:</div>
                            <div v-for="(drinkItem, drinkIndex) in itemsSold.filter(item => item.ItemType == 'Drink')" :key="drinkItem.ItemName + drinkIndex">
                                <div style="color:#0000EE">
                                    {{"- "+drinkItem.ItemName + " | Qty:"}}{{ drinkItem.Qty }} {{" | Gross:" + currencyFormat(drinkItem.Amount)}}
                                </div>
                            </div>
                        </section>
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Net Sales (Gross Sales - Credit - Refund):
                                    <currency-display :value="item.Net_Sale"/>
                                </div>
                                <div class="font-weight-bold">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Net_Sale_NAL_Drink + item.Net_Sale_Food"/>
                                </div>
                                <div class="font-weight-bold">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Net_Sale_AL_Drink"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Payments Collected (Net Sales + Tax + Tip):
                                    <currency-display :value="item.Paymeny_Received"/>
                                </div>
                                <div class="font-weight-bold">
                                    Card Pay:
                                    <currency-display :value="item.Paymeny_Received_Card"/>
                                </div>
                                <div class="font-weight-bold">
                                    Cash Pay:
                                    <currency-display :value="item.Paymeny_Received_Cash"/>
                                </div>
                                <div class="">
                                    <span> Other(All):<currency-display :value="otherPaymentBreakdown.reduce((acc, curr) => acc + curr.Paymeny_Received_OtherPaid, 0)"/> </span>
                                </div>
                                <div v-for="otherPayment in otherPaymentBreakdown" :key="'payment-print-'+otherPayment.PaymentSource">
                                    <div class="ml-2">• {{otherPayment.PaymentMethodName}} : {{currencyFormat(otherPayment.Paymeny_Received_OtherPaid)}}</div>
                                </div>
                            </section>

                            <!-- <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Payments Received (Restaurant Total) Average:
                                    <currency-display :value="item.Avg_Paymeny_Received"/>
                                </div>

                                <div class="font-weight-bold">
                                    Standard Deviation:
                                    <currency-display :value="stddev_totalpayment_received"/>
<!--                                    <currency-display :value="item.Paymeny_Received_Cash"/>
                                </div>  </section> -->
                          
                            <section>
                            <div class="">
                                Number of Orders: {{item.No_Of_Tabs}}
                            </div>
                            <div class="">
                                Average Order Value (Gross Sales):
                                <currency-display :value="item.Avg_Tab_Amount"/>
                            </div>
                            <div class="">
                                Standard Deviation Amount (Gross Sales):
                                <currency-display :value="stddev_tab_amount"/>
                            </div>
                            <div class="">
                                Average Tip Percentage: {{item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : 0}}%
                            </div>
                            <section v-if="orderSources.length > 0" class="my-4">
                                <div class="font-weight-bold" >
                                    Order Source - Type Breakdown (QTY | Gross Sales):
                                </div>
                                <div v-for="orderSource in orderSources" :key="orderSource.Source">
                                    <div class="mt-3">{{orderSource.Source}} | Qty: {{orderSource.Qty}} | Gross: {{currencyFormat(orderSource.Amount)}}</div>
                                    
                                    <div v-for="orderType in orderTypes" >
                                        <div v-if="orderType.Source == orderSource.Source" class="ml-2 ">
                                            • {{orderType.TypeName}} | Qty: {{orderType.Qty}} | Gross: {{currencyFormat(orderType.Amount)}}
                                        </div>
                                    </div>
                                
                                </div>
                            </section>
                            <div class="" v-if="result[0].No_Of_Tabs > 10">
                                <span v-if="!showAllServedTabs">Served Tab Nos: {{ getServedTabs(item.Serverd_Tabs)}}</span>
                                <span v-else>Served Tab Nos: {{ getServedTabsAll(item.Serverd_Tabs)}}</span>
                                
                                <span v-if="!showAllServedTabs" style="color: #0000EE; text-decoration: underline; font-size: 1.1rem;" class="font-weight-bold" @click="showAllServedTabs = !showAllServedTabs">...</span>
                                <span v-else style=" font-size: 1.1rem;" class="font-weight-bold text-danger" @click="showAllServedTabs = !showAllServedTabs">X</span>
                            </div>
                            <div class="" v-else>
                                Served Tab Nos: {{ getServedTabsAll(item.Serverd_Tabs)}}
                            </div>
                        </section>

                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            Note: Sales numbers are rouned to the nearest cent and may vary slightly from report to report.
                        </b-col>
                    </b-row>
                </b-container>
            </template>
        </vue-easy-print>
        <Cmodal
                v-model="printModal"
                cancel-label="Never mind"
                centered size="lg"
                title="Print Shift Receipt"
                :tag="false"
                confirm-label="Print"
                @submit="confirmPrinterSelection"
                @cancel="printModal = false"
               
        >
            <template>
                <p class="mb-3">Multiple receipt printers found. Select one to print to:</p>
                <b-form-radio-group
                    v-model="selectedPrinter"
                    buttons
                    button-variant="outline-warning"
                    size="xl"
                    class="d-flex flex-row"
                >
                    <b-form-radio
                        v-for="(item, index) in printers"
                        :key="index"
                        :value="item"
                        :button="true"
                    >
                        {{ item.PrinterName }} ({{ item.IPAddress }})
                    </b-form-radio>
                </b-form-radio-group>
            </template>
        </Cmodal>
    </b-container>
</template>

<script>
    import EmailReport from "../shared/emailReport";
    import vueEasyPrint from "vue-easy-print";
    import moment from 'moment'
    import currencyDisplay from "../shared/currencyDisplay";
    import JSPM from "jsprintmanager";
    import Cmodal from "../shared/Cmodal";
    import PrintReport from "../shared/printReport";
    import ReportSummery from "./components/reportSummery";
    export default {
        name: "serverShift",
        components: {PrintReport, EmailReport, vueEasyPrint, currencyDisplay, Cmodal, ReportSummery},
        data () {
            return {
                servers: [],
                selected: 'Receipt Printer',
                todayDate: moment().locale('en'),
                filter: {
                    ServerName: '',
                    ToDate: moment().locale('en'),
                    FromDate: moment().locale('en'),
                    IsSum: 1
                },
                type: "today",
                result: [],
                rowPrint: false,
                HasActiveReceiptPrinter: false,
                //loadPrint: false,
                printers: [],
                printModal: false,
                selectedPrinter: null,
                serverIp: '',
                printMessage: {},
                loading: false,
                errorTextApi: '',
                stddev_tab_amount: '',
                stddev_totalpayment_received: '',
                categoriesSold: [],
                itemsSold: [],
                showAllServedTabs: false,
                canShowErr: false,
                showOtherPaymentBreakdown: false,
                otherPaymentBreakdown: [],
                showOtherTipBreakdown: false,
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID'),
                        }
                        Promise.all([
                            this.getPrinters(object),
                            this.GetServerPrinterIP(object)
                        ]).then(() => {
                            moment.locale('en');
                            object.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                            object.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                            this.getServers(object)
                        })
                    }
                },
                immediate: true
            }
        },

        mounted () {
            moment.locale('en');
            
        },
        computed: {
            maxDate () {
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            oldestDate () {
                const now = new Date(this.filter.ToDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const oldestDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 18 * 30)
                return oldestDate
            },
            maxDateByToDate () {
                const now = new Date(this.filter.ToDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            minDate () {
                const now = new Date(this.filter.FromDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            isVisibleToday () {
                if (this.filter.ToDate === moment().format('YYYY-MM-DD') && this.filter.FromDate === moment().format('YYYY-MM-DD')) {
                    return true
                } else {
                    return false
                }
            },
            isVisibleYesterday () {
                if (this.filter.ToDate === moment().subtract(1, 'days').format('YYYY-MM-DD') && this.filter.FromDate === moment().subtract(1, 'days').format('YYYY-MM-DD')) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            getPrinters() {
                
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    UserID: localStorage.getItem('userID'),
                }
                this.$api.getRestaurant.GetRestaurantPrinters(model).then(res => {
                    if (res.success) {
                    
                        this.printers = res.results.RestaurantPrinter    
                        
                    }
                })
            },
            DateChange(){
                this.canShowErr = false
                this.result = []
            },
            getServedTabs(list){
                if(this.result[0].No_Of_Tabs > 10){
                    return list.split(/(?=[A-Z])|,/).slice(0, 10).join(', ')
                } else {
                    return list.split(/(?=[A-Z])|,/).join(', ')
                }
            },
            getServedTabsAll(list){
                return list.split(/(?=[A-Z])|,/).join(', ');
            },
            percentageOf (num, total) {
                if (typeof num !== 'number' || typeof total !== 'number' || total === 0) {
                    return 0;
                }
                return (num / total) * 100;
            },
            getServers (filter) {
                this.loading = true
                return this.$api.getRestaurant.GetRestaurantReportServer(filter).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.ServerName = ''
                        res.RestaurantOrderServers.forEach(item => {
                            item.fullName = item.ServerName
                        })
                        // const available = res.RestaurantClients.filter(i => i.Role.includes('Restaurant Server'))
                        this.servers = [{fullName: 'All'}, ...res.RestaurantOrderServers]
                        if (this.servers.length) {
                            this.filter.ServerName = this.servers[0].fullName
                            this.GetRestaurantShiftReport(this.filter)
                        } else {
                            this.result = []
                            this.servers = []
                        }
                    }
                }).catch(() => {

                })
            },
            changeServerName () {
                this.result = []
                this.categoriesSold = []
                this.itemsSold = []
                if (this.allFill()) {
                    this.GetRestaurantShiftReport(this.filter)
                }
                
            },
            GetRestaurantShiftReport (filter) {
                this.loading = true
                moment.locale('en');
                filter.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                filter.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                filter.ServerName = this.filter.ServerName
                filter.RestaurantID = this.$store.state.selectedRestaurantId
                filter.UserID = localStorage.getItem('userID')
                filter.CombinationType = 'SumOfAll'
                return this.$api.getRestaurant.GetRestaurantShiftReport(filter).then(res => {
                    if (res.success) {
                        const findErr = res.OpenItems.find(item => item.errMsg)
                        if (findErr) {
                            this.result = []
                            this.errorTextApi = findErr.errMsg
                            this.stddev_tab_amount = ''
                            this.stddev_totalpayment_received = ''
                        } else {
                            this.result = res.OpenItems
                            this.categoriesSold = res.CategoriesSold
                            this.orderSources = res.OrderSources
                            this.orderTypes = res.OrderTypes
                            this.itemsSold = res.ItemsSold
                            this.stddev_tab_amount = res.stddev_tab_amount
                            this.stddev_totalpayment_received = res.stddev_totalpayment_received
                            this.errorTextApi = ''
                        }
                        this.$api.getRestaurant.GetOtherPaymentBreakdown(filter).then(res => {
                            if (res.success) {
                                this.otherPaymentBreakdown = this.processOtherPaymentBreakdown(res.OtherPaymentBreakdown)
                            }
                        })
                    } else {
                        this.$showError(res.message)
                        this.result = []
                        this.errorTextApi = 'No Order exists .....'
                    }
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    console.log(error);

                })
            },

            allFill () {
                return this.filter.FromDate && this.filter.ToDate && this.filter.ServerName
            },
            processOtherPaymentBreakdown (list) {
                let breakdown = Array.isArray(list) ? list.slice() : []
                // Ensure that the element with PaymentMethodName 'Other Paid' is placed at the end of the array
                const otherPaidIndex = breakdown.findIndex(p => p.PaymentMethodName === 'Other Paid');
                if (otherPaidIndex !== -1 && otherPaidIndex !== breakdown.length - 1) {
                    const [otherPaidItem] = breakdown.splice(otherPaidIndex, 1);
                    breakdown.push(otherPaidItem);
                }
                // Remove the word "paid" (case-insensitive) from every element.PaymentMethodName
                breakdown.forEach(p => {
                    if (typeof p.PaymentMethodName === 'string') {
                        p.PaymentMethodName = p.PaymentMethodName.replace(/paid/ig, '').trim();
                    }
                });
                return breakdown
            },
            GetServerReport (filter) {
                this.getPrinters()
                if (this.allFill()) {
                    this.getServers(this.filter)
                    setTimeout(() => {
                        this.canShowErr = true
                    }, 1000)
                }
            },
            


            convertDate (date, noTime) {
                moment.locale('en');
                if (noTime) {
                    return date && moment(date).format('D MMM, YYYY')
                } else {
                    return date && moment(date).format('D MMM YYYY - hh:mm A')
                }
            },
            print () {
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.easyPrint.print()
                    })
                }, 1000)
            },
            download (filter) {
                moment.locale('en');
                filter.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                filter.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                filter.ServerName = this.filter.ServerName
                filter.RestaurantID = this.$store.state.selectedRestaurantId
                filter.UserID = localStorage.getItem('userID')
                filter.CombinationType = 'none'
                return Promise.all([
                    this.$api.getRestaurant.GetRestaurantShiftReport(filter),
                    this.$api.getRestaurant.GetOtherPaymentBreakdown(filter)
                ]).then(([res, breakdownRes]) => {
                    if (res.success) {
                        const fileName = this.dynamicNameFileByPassedDate(this.filter)
                        const otherPaymentBreakdown = (breakdownRes && breakdownRes.success) ? this.processOtherPaymentBreakdown(breakdownRes.OtherPaymentBreakdown) : []
                        this.jsonToCSV(res.OpenItems, res.CategoriesSold, res.ItemsSold, fileName, true, otherPaymentBreakdown)
                        return res.OpenItems
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {

                })
            },
            dynamicNameFileByPassedDate (filter) {
                const {FromDate, ToDate} = filter
                const startDate = FromDate.split('-')
                const endDate = ToDate.split('-')
                return 'EOD' + startDate[1] + startDate[2] + startDate[0] + 'to' + endDate[1] + endDate[2] + endDate[0]
            },
            jsonToCSV (JSONData, CategoriesSold, ItemsSold, ReportTitle, ShowLabel, otherPaymentBreakdown = []) {
                //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
                //Set Report title in first row or line
                var CSV = '\n';
                const tipOtherBreakdownCols = otherPaymentBreakdown.map(p => `Total Tip - Other (${p.PaymentMethodName})`)
                const paymentOtherBreakdownCols = otherPaymentBreakdown.map(p => `Total Payment Received - Other (${p.PaymentMethodName})`)
                if (ShowLabel) {
                    var row = "";
                    let staticCol = ['Date', 'Server', 'Total Gross Sales (Subtotals)', 'Total Gross Sales - Food','Total Gross Sales - Alc Drink','Total Gross Sales - Non-Alc Drink','Total Credit (Comp & Discount) Applied:','Total Voids (Cancelled Orders)', 'Total Refunds',
                    'Total Net Sales', 'Total Net Sales - Food', 'Total Net Sales - Alc Drink', 'Total Net Sales - Non-Alc Drink', 'Total Tax', 'Total Tax - Food & Non-Alc Drink', 'Total Tax - Alc Drink', 'Total Tip', 'Total Tip - Card', 'Total Tip - Cash','Total Tip - Other',
                    ...tipOtherBreakdownCols,
                    'Total Payment Received', 'Total Payment Received - Card', 'Total Payment Received - Cash','Total Payment Received - Other',
                    ...paymentOtherBreakdownCols,
                    'Tip Out to House', 'Cash Owed to House', 'Money Owed to Server', 'Number of Orders',
                    'Average Order Value', 'Average Tip Percentage', 'Served Tab No', 'Total Payments Received (Restaurant Total) Average:', 'Standard Deviation Amount (Gross Sales)', 'Standard Deviation'
                    ]
                    let allCol = staticCol
                    //This loop will extract the label from 1st index of on array
                    for (var index in allCol) {

                        //Now convert each value to string and comma-seprated
                        row += allCol[index] + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\n';
                }
                let dataRow = []
                arrData.forEach((item, index) => {
                    let obj = {
                        // Date: moment(item.FromDate).format('MMM YY') + ' - ' + moment(item.ToDate).format('MMM YY'),
                        Date: moment(item.OrderDate).format('D MMM, YYYY'),
                        Server: item.ServerName,
                        Total_gross_sale: this.currencyFormat(item.Gross_Sale),
                        food_gross_sale: this.currencyFormat(item.Gross_Sale_Food),
                        alc_drink_gross_sale: this.currencyFormat(item.Gross_Sale_AL_Drink),
                        no_alc_drink_gross_sale: this.currencyFormat(item.Gross_Sale_NAL_Drink),
                        credit: this.currencyFormat(item.Credits),
                        voids: this.currencyFormat(item.Voids),
                        refunds: this.currencyFormat(item.Refunds),
                        total_net_sales: this.currencyFormat(item.Net_Sale),
                        food_net_sales: this.currencyFormat(item.Net_Sale_Food),
                        alc_net_sales: this.currencyFormat(item.Net_Sale_AL_Drink),
                        no_alc_net_sales: this.currencyFormat(item.Net_Sale_NAL_Drink),
                        total_tax: this.currencyFormat(item.Taxes),
                        food_nan_alc_tax: this.currencyFormat(item.Tax_Food_NAL_Drink),
                        alc_drink_tax: this.currencyFormat(item.Tax_Alc_Drink),
                        total_tip: this.currencyFormat(item.Tips),
                        tip_card: this.currencyFormat(item.Tip_Card),
                        tip_cash: this.currencyFormat(item.Tip_Cash),
                        tip_other:  this.currencyFormat(item.Tip_OtherPaid),
                    }
                    otherPaymentBreakdown.forEach((p, breakdownIndex) => {
                        obj['tip_other_breakdown_' + breakdownIndex] = this.currencyFormat(p.Tip_OtherPaid)
                    })
                    obj.total_payment = this.currencyFormat(item.Paymeny_Received)
                    obj.total_payment_card = this.currencyFormat(item.Paymeny_Received_Card)
                    obj.total_payment_cash = this.currencyFormat(item.Paymeny_Received_Cash)
                    obj.total_payment_other = this.currencyFormat(item.Paymeny_Received_OtherPaid)
                    otherPaymentBreakdown.forEach((p, breakdownIndex) => {
                        obj['total_payment_other_breakdown_' + breakdownIndex] = this.currencyFormat(p.Paymeny_Received_OtherPaid)
                    })
                    obj.tip_out_house = this.currencyFormat(item.Tip_Outhouse)
                    obj.cash_owed_house = item.Server_Balance <= 0 ? this.currencyFormat(Math.abs(item.Server_Balance)) : '$0.00'
                    obj.money_owed = item.Server_Balance > 0 ? this.currencyFormat(Math.abs(item.Server_Balance)) : '$0.00'
                    obj.tab_no = item.No_Of_Tabs
                    obj.avg_tab_amount = this.currencyFormat(item.Avg_Tab_Amount)
                    obj.avg_tip_percent = item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : 0
                    obj.serve_tab_no = item.Serverd_Tabs
                    obj.Avg_Paymeny_Received = this.currencyFormat(item.Avg_Paymeny_Received)
                    obj.stddev_tab_amount = this.currencyFormat(this.stddev_tab_amount)
                    obj.stddev_totalpayment_received = this.currencyFormat(this.stddev_totalpayment_received)
                    dataRow.push(obj)
                })
                for (var i = 0; i < dataRow.length; i++) {
                    var row = "";
                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in dataRow[i]) {
                        row += '"' + dataRow[i][index] + '",';
                    }
                    row.slice(0, row.length - 1);
                    //add a line break after each row
                    CSV += row + '\n';
                }


                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                var fileName = ReportTitle;
                //this will remove the blank-spaces from the title and replace it with an underscore
                // fileName += ReportTitle.replace(/ /g,"");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF,' + encodeURI(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // ---- Additional files for CategoriesSold and ItemsSold ----
                let soldHeader = ['RowType', 'ItemName', 'Qty', 'Gross Amount'];

                // CategoriesSold file
                if (CategoriesSold && CategoriesSold.length) {
                    let csvCategories = soldHeader.join(',') + '\n';
                    let index = 1;
                    CategoriesSold.forEach(item => {
                        const rowType = item.RowType || '';
                        const name = item.ItemName || '';
                        const qty = typeof item.Qty === 'number' ? item.Qty.toFixed(2) : '';
                        const amount = typeof item.Amount === 'number' ? this.currencyFormat(item.Amount) : '';
                        csvCategories += `"${index}","${rowType}","${name}",${qty},"${amount}"\n`;
                        index++;
                    });

                    const uriCategories = 'data:text/csv;charset=utf-8,%EF%BB%BF,' + encodeURI(csvCategories);
                    const linkCategories = document.createElement("a");
                    linkCategories.href = uriCategories;
                    linkCategories.style = "visibility:hidden";
                    linkCategories.download = fileName + "_CategoriesSold.csv";
                    document.body.appendChild(linkCategories);
                    linkCategories.click();
                    document.body.removeChild(linkCategories);
                }
                soldHeader = ['Item Type','RowType', 'ItemName', 'Qty', 'Gross Amount'];
                // ItemsSold file
                if (ItemsSold && ItemsSold.length) {
                    let csvItems = soldHeader.join(',') + '\n';
                    let index = 1;
                    ItemsSold.forEach(item => {
                        console.log(item);
                        const itemType = item.ItemType || '';
                        const rowType = item.RowType || '';
                        const name = item.ItemName || '';
                        const qty = typeof item.Qty === 'number' ? item.Qty.toFixed(2) : '';
                        const amount = typeof item.Amount === 'number' ? this.currencyFormat(item.Amount) : '';
                        csvItems += `"${index}","${itemType}","${rowType}","${name}",${qty},"${amount}"\n`;
                        index++;
                    });

                    const uriItems = 'data:text/csv;charset=utf-8,%EF%BB%BF,' + encodeURI(csvItems);
                    const linkItems = document.createElement("a");
                    linkItems.href = uriItems;
                    linkItems.style = "visibility:hidden";
                    linkItems.download = fileName + "_ItemsSold.csv";
                    document.body.appendChild(linkItems);
                    linkItems.click();
                    document.body.removeChild(linkItems);
                }

            },
            changeDateMode (type) {
                this.type = type
                moment.locale('en');
                this.result = []
                this.categoriesSold = []
                this.itemsSold = []
                if (type === 'today') {
                    this.filter.FromDate = moment().locale('en').format('YYYY-MM-DD')
                    this.filter.ToDate = moment().locale('en').format('YYYY-MM-DD')
                    
                } else {
                    this.filter.FromDate = moment().locale('en').subtract(1, 'days').format('YYYY-MM-DD')
                    this.filter.ToDate = moment().locale('en').subtract(1, 'days').format('YYYY-MM-DD')
                    
                }
            },
            // getPrinters (object) {
            //     this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
            //         if (res.success) {
            //             this.printers = res.results.RestaurantPrinter.filter(i => i.PrintTaskID === 2)
            //             this.printers.forEach(item => {
            //                 this.$set(item, 'deactive', false)
            //             })
            //         }
            //     })
            // },
            GetServerPrinterIP (object) {
                this.$api.getRestaurant.GetServerPrinterIP(object).then(res => {
                    if (res.success) {
                        this.serverIp = res.results.serverPrinterIp
                        this.onInit(this.serverIp)
                    }
                })
            },
            onInit (serverIp) {
                if (serverIp && this.printers.length) {
                    var _this = this;
                    JSPM.JSPrintManager.license_url = _this.$config.printJspmLisence
                    JSPM.JSPrintManager.auto_reconnect = false;
                    JSPM.JSPrintManager.start(true, serverIp, 23443)
                    JSPM.JSPrintManager.WS.onStatusChanged = function () {
                        _this.loadPrint = true
                    };
                }
            },
            currencyFormat (value) {
                return value === 0 ? '0.00' : ('$' + value.toFixed(2))
            },
            handlePrintShiftReceipt() {
                if (this.printers.length > 1) {
                    this.selectedPrinter = this.printers[0]
                    this.printModal = true
                } else if (this.printers.length === 1) {
                    this.sendShiftReportPrintToApp(this.printers[0])
                } else {
                    this.$showError('No printers available')
                }
            },
            confirmPrinterSelection() {
                this.printModal = false
                if (this.selectedPrinter) {
                    this.sendShiftReportPrintToApp(this.selectedPrinter)
                }
            },
            sendShiftReportPrintToApp(printer) {
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    ServerName: this.filter.ServerName,
                    IpAdderss: printer.IPAddress,
                    FromDate: moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD'),
                    ToDate: moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD'),
                    CombinationType: 'SumOfAll'
                }
                
                
                this.$api.getRestaurant.SendShiftReportPrintToApp(model).then(res => {
                    if (res.success) {
                        this.$showSuccess('Print sent successfully')
                    } else {
                        this.$showError(res.message || 'Failed to send print')
                    }
                }).catch(err => {
                    this.$showError('Error sending print: ' + err)
                })
            }
        }
    }
</script>

<style scoped>
    #printSection{
        display: none;
    }
    @media print {
        #printSection{
            display: block;
        }
    }
    .active-button-group {
        background-color: chartreuse;
        color: #000;
        font-weight: bold;
    }
    .border-bottom-blueGray{
        border-bottom: 1px solid lightgray !important;
    }
    .item-group{
        
        gap: 0.5rem 1rem;
    }
</style>
